module.exports = __webpack_public_path__ + "static/media/1.82f6e8ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/悬浮窗/1.png
// module id = 1657
// module chunks = 0